import { IFRMParams } from "../Controls/FormParameters";
import { FrameContext, IWindowable } from "../UIManagerInterfaces";
/**
 * Rozhraní, které sestaví formuláře pro verze dokumentu.
 * @includeToDoc
 */
export interface IFormBuilder {
    /**
     * Sestaví generický formulář
     */
    build(...params: any): Promise<IWindowable> ;
}

/**
 * Rozhraní, které sestaví formuláře pro verze dokumentu.
 * @includeToDoc
 */
export interface IShowArchiveVersionsFormBuilder extends IFormBuilder {
    /**
     * Sestaví formulář pro zobrazení verzí dokumentu
     * @param className Třída objektu
     * @param id ID objektu
     * @param instanceID Instance objektu
     * @param attrName Atribut objektu
     * @param parametricData Volitelné parametry formuláře
     * @param frameContext Viz {@link IFrameContext}
     */
    build(className: string, id: string, instanceID: string, attrName: string, parametricData: IFRMParams, frameContext?: FrameContext): Promise<IWindowable>;
}

export class IShowArchiveVersionsFormBuilder {
    private static _methods = ["build"];
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._methods.some(value => typeof instance[value] !== "function");
    }
}

/**
 * Sestaví modální formulář pro zobrazení ChartFrame
 * @includeToDoc
 */
export interface IChartFrameFormBuilder extends IFormBuilder {
    /**
     * Sestaví modální formulář pro ChartFrame
     * @param parametricData Volitelné parametry formuláře
     */
    build(parametricData?: IFRMParams): Promise<IWindowable>;
}

export class IChartFrameFormBuilder {
    private static _methods = ["build"];
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._methods.some(value => typeof instance[value] !== "function");
    }
}
